<template>
<a-config-provider :locale="locale">
  <div id="app">
    <router-view/>
  </div>
  </a-config-provider>
</template>

<script>
import cn from 'ant-design-vue/es/locale/zh_CN';
import dayjs from 'dayjs';
import 'dayjs/locale/zh-cn';
 dayjs.locale('zh-cn');
 dayjs().locale('zh-cn').format('YYYY-MM-DD hh:mm:ss')
export default {
  name: 'App',
  data() {
    return {
      locale : cn,
    }
  }
  
}
</script>

<style>
#app {
   width: 100%;
  height: 100%;
  overflow: hidden;
}
body {
  font-size:16.25
}

</style>
